import React, { PureComponent } from 'react';
import { branch } from 'baobab-react/higher-order';

import Player from "./components/player/player";

class Activity extends PureComponent {
	render() {
		return (
			<div className="ambifi-web-player">
				<Player />
				{/* <pre>{JSON.stringify(this.props.activity,null,3)}</pre> */}
			</div>
		);
	}
}
export default branch({
	activity: ["activity"]
}, Activity);
